;(function () {
  angular
    .module('contrast.discussion')
    .directive('discussionIndicator', function () {
      return {
        restrict: 'E',
        scope: {
          total: '=',
          unread: '='
        },
        templateUrl: 'views/common/discussion_indicator.html'
      }
    })
})()
